import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  CmsConfig,
  ConfigModule,
  I18nConfig,
  I18nModule, OccConfig, provideConfig,
  UrlModule
} from '@spartacus/core';
import {
  GenericLinkModule,
  IconModule,
  LayoutConfig,
  MediaModule,
  NavigationModule,
  SearchBoxComponentService
} from '@spartacus/storefront';
import { UigPipesModule } from '../pipes/uig-pipes.module';
import { UigAuthModule } from './uig-auth/uig-auth.module';
import { UigBannerModule } from './uig-banner/uig-banner.module';
import { UigBreadcrumbComponent } from './uig-breadcrumb/uig-breadcrumb.component';
import { UigCartModule } from './uig-cart/uig-cart.module';
import { UigCategoryNavigationModule } from './uig-category-navigation/uig-category-navigation.module';
import { UigCheckoutModule } from './uig-checkout/uig-checkout.module';
import { UigContentSearchModule } from './uig-content-search/uig-content-search.module';
import { UigContentModule } from './uig-content/uig-content.module';
import { UigEtilizeRedirectModule } from './uig-etilize-redirect/uig-etilize-redirect.module';
import { UigExportProductsComponent } from './uig-export-products/uig-export-products.component';
import { UigExportComponent } from './uig-export/uig-export.component';
import { UigFooterNavigationComponent } from './uig-footer-navigation/uig-footer-navigation.component';
import { UigFooterComponent } from './uig-footer/uig-footer.component';
import { UigHeaderModule } from './uig-header/uig-header.module';
import { UigNavigationModule } from './uig-navigation/uig-navigation.module';
import { UigNewsModule } from './uig-news/uig-news.module';
import { UigParagraphModule } from './uig-paragraph/uig-paragraph.module';
import { UigProductCarouselModule } from './uig-product/uig-product-carousel/uig-product-carousel.module';
import { UigProductReferencesModule } from './uig-product/uig-product-references/uig-product-references.module';
import { UigProductModule } from './uig-product/uig-product.module';
import { UigQuestionnaireFormModule } from './uig-questionnaire-form/uig-questionnaire-form.module';
import { UigSearchBoxComponent } from './uig-search-box/uig-search-box.component';
import { UigShopViewModule } from './uig-shop-view/uig-shop-view.module';
import { UigWishListModule } from './uig-wish-list/uig-wish-list.module';
import { UigBannerCarouselModule } from './uig-banner-carousel/uig-banner-carousel.module';
import { UigCarouselModule } from './uig-carousel/uig-carousel.module';
import { UigCmsLinkModule } from './uig-cms/uig-cms.module';
import { UigSearchBoxComponentService } from './uig-product/services/uig-search-box-component.service';

@NgModule({
    imports: [
        I18nModule,
        RouterModule,
        CommonModule,
        NgSelectModule,
        NavigationModule,
        GenericLinkModule,
        FormsModule,
        IconModule,
        MediaModule,
        UrlModule,
        UigPipesModule,
        UigProductModule,
        UigContentModule,
        UigCheckoutModule,
        UigCartModule,
        UigWishListModule,
        UigContentSearchModule,
        UigNewsModule,
        UigParagraphModule,
        UigProductReferencesModule,
        UigProductCarouselModule,
        UigBannerModule,
        UigAuthModule,
        UigNavigationModule,
        UigQuestionnaireFormModule,
        UigShopViewModule,
        UigCategoryNavigationModule,
        UigHeaderModule,
        UigEtilizeRedirectModule,
        UigBannerCarouselModule,
        UigCarouselModule,
        UigCmsLinkModule,
        ConfigModule.withConfig({
            layoutSlots: {
                ProductDetailsPageTemplate: {
                    slots: [
                        'ProductCampaignsSlot',
                        'Summary',
                        'AllProductReferences',
                        'Tabs',
                        'PlaceholderContentSlot',
                    ]
                }
            },
        } as LayoutConfig),
        ConfigModule.withConfig({
            backend: {
                occ: {
                    endpoints: {
                        exportProductList: '/product/export',
                    },
                },
            },
        } as OccConfig),
        ConfigModule.withConfig({
            cmsComponents: {
                FooterNavigationComponent: {
                    component: UigFooterComponent
                },
                SearchBoxComponent: {
                    component: UigSearchBoxComponent,
                },
                BreadcrumbComponent: {
                    component: UigBreadcrumbComponent,
                },
            }
        } as CmsConfig)
    ],
    providers: [
        {
            provide: SearchBoxComponentService,
            useClass: UigSearchBoxComponentService
        },
        provideConfig(<I18nConfig>{
            i18n: {
                chunks: { uigComponents: ['uigQuestionnaire', 'uigexport', 'uigCheckout', 'uigLegal', 'searchTypes', 'product', 'priceCalculator', 'contentSearch', 'search', 'shopView', 'etilize', 'marketplace'] },
            },
        }),
    ],
    declarations: [
        UigFooterComponent,
        UigFooterNavigationComponent,
        UigExportComponent,
        UigExportProductsComponent,
        UigSearchBoxComponent,
        UigBreadcrumbComponent,
    ],
    exports: [
        UigFooterComponent,
        UigFooterNavigationComponent,
        UigSearchBoxComponent,
        UigBreadcrumbComponent
    ]
})
export class ComponentsModule { }
